<template>
  <div class="container reportDetail_reportItem">
    <el-row style="margin-bottom:20px">
      <el-button v-if="value.canEdit || value.canAnswer" type="primary" v-acl="Feedback-questionsAnswer" @click="save" :disabled="preventManyClick">{{$t("common.save")}}</el-button>
      <el-button v-if="value.canEdit || value.canAnswer" type="primary" v-acl="Feedback-questionsAnswer" @click="submit" :disabled="preventManyClick">
        {{$t("common.submit")}}
      </el-button>
      <el-button type="primary" @click="goBack">{{$t('common.close')}}</el-button>
      <!--关闭-->
    </el-row>
    <el-form :model="feedbackReport" label-position="right" label-width="43%">
      <el-card>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.feedbackNo')">
              <el-input :value="feedbackHead.feedbackNo" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.feedbackStatus')">
              <!--问题报告状态  -->
              <el-input :value="feedbackHead.workflowStatus|ic('TT_FEEDBACK','OTHER_PROCESS_NODE')" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.reportNo')">
              <el-input :value="feedbackReport.reportNo" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.reportType')" prop="reportType">
              <!-- 调查报告类型 -->
              <IcSelect table="TT_FEEDBACK_REPORT" field="REPORT_TYPE" v-model="feedbackReport.reportType" clearable :disabled="!feedbackReport.canEdit"></IcSelect>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if='!(value.canEdit || taskApproval)'>
            <!-- 新增 审批 的时候不要显示 -->
            <el-form-item :label="$t('storeFeedback.report.haveInterrogativeCommunication')">
              <!-- 是否发起疑问沟通 -->
              <el-input :value="!!feedbackReport.answer?'Y':'N'|ic('COMMON','YES_NO')" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if='!(value.canEdit || taskApproval)'>
            <el-form-item :label="$t('storeFeedback.report.doubtCommunicationStatus')">
              <!-- 疑问沟通状态 -->
              <el-input :value="feedbackReport.answerStatus|ic('TT_FEEDBACK_REPORT','QUESTION_STATUS')" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.supplierCostTime')">
              <!-- 供应商调查花费时间（小时） 供应商/MCD查看的时候有，新增时候没有-->
              <el-input :value="(feedbackReport.supOperateTime/1).toFixed(2)" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.remark')" prop="reportRemark" class="widthReset">
              <el-input v-model="feedbackReport.reportRemark" clearable :disabled="!feedbackReport.canEdit"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card>
        <!-- 基本信息 -->
        <div slot="header" class="clearfix">
          <span>{{$t("storeFeedback.report.basicInfo")}}</span>
        </div>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.receiveDate')">
              <!-- 接到反馈日期 -->
              <el-date-picker :value="feedbackReport.receiveDate | dateFormatFilter('YYYY-MM-DD')" type="date" disabled clearable></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.problemLevel')">
              <!-- 投诉问题类别 -->
              <el-input :value="feedback.feedbackFirstCheck.problemLevel" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.deadline')" v-if="!isStore">
              <!-- 初次最晚提交时间 -->
              <el-input :value="feedbackReport.reportDeadline|dateFormatFilter('YYYY-MM-DD HH:mm:ss')" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.haveRejected')" v-if="!isStore">
              <!-- 是否被CQS退回过 -->
              <el-input v-if='feedbackReport.haveRejectedByCqs' :value="feedbackReport.haveRejectedByCqs|ic('COMMON','YES_NO')" disabled clearable></el-input>
              <el-input v-else value="否" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.canContinue')" prop="canContinue">
              <!--能否继续使用-->
              <IcSelect table="COMMON" field="YES_NO" v-model="feedbackReport.canContinue" clearable :disabled="!feedbackReport.canEdit"></IcSelect>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.sampleHandleMethod')" prop="sampleHandleMethod">
              <!--留样处理-->
              <ic-select v-model="feedbackReport.sampleHandleMethod" table="TT_FEEDBACK_REPORT" field="SAMPLE_HANDLE_METHOD" clearable :disabled="!feedbackReport.canEdit"></ic-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.responsibleParty')" prop="responsibleParty">
              <!--责任方-->
              <ic-select v-model="feedbackReport.responsibleParty" :table-fields="responsiblePartyField" clearable :disabled="!feedbackReport.canEdit"></ic-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.needDebit')" prop="needDebit">
              <!--是否扣账-->
              <el-select v-model="feedbackReport.needDebit" @change='needDebitChange' clearable :disabled="!feedbackReport.canEdit">
                <el-option value="Y" label="是">是</el-option>
                <el-option value="N" label="否">否</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.debitNumber')">
              <!--扣账数量-->
              <el-input onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" v-model="feedbackReport.debitNumber" clearable :disabled="!feedbackReport.canEdit || !isneedDebit" maxLength='9'></el-input>
              <!-- <el-input-number v-model="feedbackReport.debitNumber" clearable  :disabled="!feedbackReport.canEdit"></el-input-number> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('storeFeedback.report.debitUnit')">
              <!--扣账数量单位-->
              <ic-select v-model="feedbackReport.debitUnit" table="TT_FEEDBACK" field="UNIT" clearable :disabled="!feedbackReport.canEdit"></ic-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card>
        <!--详细调查报告-->
        <div slot="header" class="clearfix"><span>{{$t("storeFeedback.report.reportDetail")}}</span></div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.description')" prop="reportDetail">
              <!--描述-->
              <el-input type="textarea" autosize v-model="feedbackReport.reportDetail" clearable :disabled="!feedbackReport.canEdit" maxlength="1000"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.DocAttachment')" prop="reportDetailDoc">
              <el-table :data="feedbackReport.reportDetailDoc" border highlight-current-row class="tableFile">
                <el-table-column sortable prop="documentName" :label="$t('common.file')">
                  <!--文件-->
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
                  </template>
                </el-table-column>
              </el-table>
              <el-upload v-if="feedbackReport.canEdit" ref="reportDetailDoc" action="upload" :http-request="reportDetailDocUpload" multiple :on-remove="reportDetailDocRemove" show-file-list="false" name="file">
                <el-button slot="trigger" size="small" type="primary">{{$t('common.selectFile')}}</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.PicAttachment')">
              <el-upload class="hide" :on-preview="reportDetailImgPreview" disabled list-type="picture-card" action="upload" :file-list="reportDetailImg">
                <div slot="file" slot-scope="{file}">
                  <el-input v-model="file.docComments" clearable disabled></el-input>
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                  <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="reportDetailImgPreview(file)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span v-if="file.tmDocumentId" class="el-upload-list__item-delete" @click="downloadFile(file)">
                      <i class="el-icon-download"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card>
        <!-- 改进措施 -->
        <div slot="header"><span>{{$t("storeFeedback.report.treatment")}}</span></div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.description')">
              <el-input type="textarea" autosize v-model="feedbackReport.treatment" clearable :disabled="!feedbackReport.canEdit" maxlength="1000"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.attachment')">
              <el-table :data="feedbackReport.treatmentDoc" border highlight-current-row class="tableFile">
                <el-table-column sortable prop="documentName" :label="$t('common.file')">
                  <!--文件-->
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
                  </template>
                </el-table-column>
              </el-table>
              <el-upload v-if="feedbackReport.canEdit" ref="treatmentDoc" action="upload" :http-request="treatmentDocUpload" multiple :on-remove="treatmentDocRemove" show-file-list="false" name="file">
                <el-button slot="trigger" size="small" type="primary">{{$t('common.selectFile')}}</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card>
        <!-- 调查分析简报（反馈中心）-->
        <div slot="header"><span>{{$t("storeFeedback.report.CQSAnalysis")}}</span></div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.description')" prop='cqsAnalysis'>
              <el-input type="textarea" row="3" autosize v-model="feedbackReport.cqsAnalysis" :disabled="!feedbackReport.canAudit" clearable maxlength="1000"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
    </el-form>
    <el-form :model="feedbackReport" ref="reportForm" label-position="right" label-width="30%" :rules="feedbackReportRules">
      <el-card>
        <!-- 门店疑问-->
        <span>{{$t("storeFeedback.report.questionOfStore")}}</span>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.description')">
              <!-- <el-input type="textarea" autosize v-model="feedbackReport.question" :disabled="!feedbackReport.canAsk"></el-input> -->
              <el-input type="textarea" autosize v-model="feedbackReport.question" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.attachment')">
              <el-table :data="feedbackReport.questionDoc" border highlight-current-row class="tableFile">
                <el-table-column sortable prop="documentName" :label="$t('common.file')">
                  <!--文件-->
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
                  </template>
                </el-table-column>
              </el-table>
              <!-- <store-feedback-attachments :docList.sync="feedbackReport.questionDoc" :img-list.sync="feedbackReport.questionImg" :disabled="!feedbackReport.canAsk"></store-feedback-attachments> -->
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card>
        <!-- 疑问回复-->
        <div slot="header"><span>{{$t("storeFeedback.report.answerOfFBC")}}</span></div>
        <el-row :gutter="16">
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.description')" prop="answer">
              <el-input type="textarea" autosize v-model="feedbackReport.answer" :disabled="!feedbackReport.canAnswer" maxlength="1000"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label-width="15%" :label="$t('storeFeedback.report.attachment')" prop="answerDoc">
              <el-table :data="feedbackReport.answerDoc" border highlight-current-row class="tableFile">
                <el-table-column sortable prop="documentName" :label="$t('common.file')">
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="tmDocumentId" min-width="130px" v-if="value.canEdit || value.canAnswer">
                  <template slot-scope="scope">
                    <el-link type="primary" @click.native.prevent="deleteFile(scope.row.tmDocumentId,scope.$index,feedbackReport.answerDoc)">{{$t('common.del')}}</el-link>
                    <!--删除-->
                  </template>
                </el-table-column>
              </el-table>
              <el-upload v-if="feedbackReport.canAnswer" ref="answerDoc" action="answerDoc" :http-request="answerDocUpload" multiple :before-upload="answerBeforeUpload" :on-remove="answerDocRemove" show-file-list="false" name="file">
                <el-button slot="trigger" size="small" type="primary">{{$t('common.selectFile')}}</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
    </el-form>
  </div>
</template>
<script>
import reportApi from "@/api/storeFeedback/report";
import IcSelect from "@/components/common/icSelect";
import FileList from "@/components/common/fileList";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";
import StoreFeedbackAttachments from "@/components/page/storeFeedback/storeFeedbackAttachments";
import { fileService } from "@/api/common/file-utils";
export default {
  name: "report-detail_report-item",
  components: { StoreFeedbackAttachments, FileList, IcSelect },
  props: {
    value: Object,
    feedback: Object,
    disabled: String,
  },
  data() {
    var answerDocValidator = (rule, value, callback) => {
      if (this.answerDoc2.length == 0 && this.feedbackReport.answerDoc.length == 0)
        callback(new Error(this.$t("storeFeedback.report.uploadFile")));
      else {
        callback();
      }
    };
    return {

      dialogImageUrl: '',
      dialogVisible: false,
      questionDialogVisible: false,//疑问沟通弹框
      isNew: false,
      isStore: false,
      isFBC: false,
      isMCD: false,
      isSUP: false,
      taskApproval: false,
      reportDetailDoc: [],//详细调查报告
      reportDetailDoc2: [],
      reportDetailImg: [],//详细调查报告  图片
      reportDetailImg2: [],
      treatmentDoc: [],//改进措施
      treatmentDoc2: [],
      questionDoc: [],//门店疑问
      questionDoc2: [],
      answerDoc: [],//疑问回复
      answerDoc2: [],
      preventManyClick: false,
      disableQuestion: false,
      showQuestion: true,
      feedbackHead: this.feedback.feedback,
      feedbackReport: this.value,
      feedbackFirstCheck: this.feedback.feedbackFirstCheck,
      isneedDebit: false,
      feedbackReportRules: {
        answer: [{ required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }],
        // answerDoc:[{ required: true, validator: answerDocValidator,trigger: 'change' }],

      },
    }
  },
  created() {
    let roles = JSON.parse(localStorage.getItem("ms_roles"));
    let emplFlag = localStorage.getItem('ms_emplFlag');
    //门店      SF_STORE_BASIC
    //反馈中心  SF_FBC_BASIC
    //麦当劳   SF_MCD_BASIC
    //供应商  SF_SUP_BASIC
    for (let i = 0, len = roles.length; i < len; i++) {
      if (roles[i] == 'SF_STORE_BASIC') {//门店
        this.isStore = true;
      }
      if (roles[i] == 'SF_FBC_BASIC') {//反馈中心
        this.isFBC = true;
      }
      if (roles[i] == 'SF_MCD_BASIC') {//麦当劳
        this.isMCD = true;
      }

    }
    if (emplFlag == "SUP") {//供应商
      this.isSUP = true;
    }
    if (this.$route.query.action) {
      let action = this.$route.query.action;
      if (action == 'create') {
        this.isNew = true
      } else {
        this.isNew = false
      }
    }
    if (this.$route.query.taskApproval) {//如果从 任务里 进来的（审批）
      this.taskApproval = true

    }
  },
  mounted() {
    this.getData();
  },
  computed: {
    dataChanged() {
      let { value, feedback } = { value: this.value, feedback: this.feedback };
      return { value, feedback };
    },
    haveQuestion() {
      return !!this.feedbackReport.question ? 'Y' : 'N';
    },
    questionStatus() {
      if (commonFun.isEmpty(this.feedbackReport.question)) {
        return "NO_QUESTION";
      } else {
        if (commonFun.isEmpty(this.feedbackReport.answer)) {
          return "PENDIND";
        } else {
          return "ANSWERED";
        }
      }
    },
    responsiblePartyField() {
      if (commonFun.isNotEmpty(this.feedbackReport.supplierType)) {
        if (this.feedbackReport.supplierType == "DC" || this.feedbackReport.supplierType == "CARRIER") {
          return [{ table: 'FEEDBACK_REPORT', field: "RESPONSIBLE_PARTY_DC" }];
        } else if (this.feedbackReport.supplierType == 'PLANT' || this.feedbackReport.supplierType == 'SUPPLIER') {
          return [{ table: 'FEEDBACK_REPORT', field: "RESPONSIBLE_PARTY_SUP" }];
        }
      } else {
        return [{ table: 'FEEDBACK_REPORT', field: "RESPONSIBLE_PARTY_DC" }, { table: 'FEEDBACK_REPORT', field: "RESPONSIBLE_PARTY_SUP" }];
      }
    }
  },
  methods: {
    getData() {
      let action = this.$route.query.action;
      this.feedbackHead = this.feedback.feedback;
      this.feedbackReport = this.value;
      this.feedbackFirstCheck = this.feedback.feedbackFirstCheck;
      let reportDetailImg = this.value.reportDetailImg
      if (reportDetailImg != null && reportDetailImg.length > 0) {
        var temp = reportDetailImg.map(function (item) {
          let obj = {
            name: item["documentName"],
            url: '/adminconsole/file/downloadByKey?key=' + item["documentKey"],
            docComments: item["docComments"],
            fullPath: item["fullPath"],
            tmDocumentId: item["tmDocumentId"],
            documentName: item["documentName"],
            downloadType: item["downloadType"]
          };
          return obj;
        });
        this.reportDetailImg = temp
        this.reportDetailImg2 = reportDetailImg
      }
    },
    save() {
      this.preventManyClick = true
      let that = this;
      this.feedbackReport.answerDoc = that.feedbackReport.answerDoc.concat(that.answerDoc2);
      reportApi.save(this.feedbackReport).then(resp => {
        if (resp.code != 200) {
          Message.error(resp.msg);
        } else {
          that.preventManyClick = false
          that.getData()
          that.$refs.answerDoc.clearFiles()
          Message.success(that.$t("common.saveSuccess"));
          that.$router.replace({
            name: `feedbackReportQuestionDetail`,
            query: {
              feedbackReportId: resp.data.ttFeedbackReportId,
              timestamp: new Date().getTime()
            }
          })
        }
      })
    },
    submit() {
      let that = this;
      this.$refs.reportForm.validate(valid => {
        if (valid) {
          this.preventManyClick = true
          this.feedbackReport.auditStatus = 'SUBMIT';
          this.feedbackReport.answerDoc = that.feedbackReport.answerDoc.concat(that.answerDoc2);
          console.log(this.feedbackReport)
          reportApi.save(this.feedbackReport).then(resp => {
            if (resp.code != 200) {
              Message.error(resp.msg);
            } else {
              that.getData()
              that.preventManyClick = false
              that.$refs.answerDoc.clearFiles()
              Message.success(that.$t("common.submitSuccess"));
              that.$router.replace({
                name: `feedbackReportQuestionDetail`,
                query: {
                  feedbackReportId: resp.data.ttFeedbackReportId,
                  timestamp: new Date().getTime()
                }
              })
            }
          })
        } else {
          return false;
        }
      });
    },
    //疑问回复 附件上传
    answerDocUpload: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        _this.answerDoc2.push(res.data[0])
        _this.$refs.reportForm.validateField('answerDoc');
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //疑问回复 删除(没保存前)
    answerDocRemove(file) {
      for (let j = 0; j < this.answerDoc2.length; j++) {
        if (this.answerDoc2[j].documentName == file.name) {
          this.answerDoc2.splice(j, 1)
        }
      }
    },
    answerBeforeUpload(file) {
      let _this = this;
      if(file.name&&file.name.length>100) {
        _this.$message.error("附件名称过长，请修改后再传");
        return false;
      }
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then(res => { });
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files) {
      let that = this
      fileService.deleteFile(tmDocumentId).then((res) => {
        this.$message({
          type: "success",
          message: this.$t("common.delSuccess"),
        });
        files.splice(index, 1);
        that.getData()
      })
    },

    needDebitChange(val) {
      if (val == "Y") {
        this.isneedDebit = true
      } else {
        this.isneedDebit = false
      }
    },
    showQuestionFun() {
      this.questionDialogVisible = true
    },
    goBack() {
      this.$router.push({//返回列表
        name: `feedbackReportQuestion`,
      })
    },
    //详细调查报告 图片上传
    reportDetailImgUpload: function (response, file, fileList) {
      this.reportDetailImg2.push(response.data[0])
      this.reportDetailImg.push(file)
      Message({ message: this.$t('common.UploadSucceed'), type: "success" });
    },
    reportDetailImgPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
  },
  watch: {
    dataChanged(newVal) {
      this.getData();
    }
  }
}

</script>
<style scoped  lang="scss">
.reportDetail_reportItem {
  .tableFile {
    margin-bottom: 20px;
  }
}
</style>
<style  lang="scss">
.reportDetail_reportItem {
  .el-input__inner {
    width: 100%;
  }
  .el-select {
    width: 100%;
  }
  .el-input-number {
    width: 100%;
  }
  .el-date-editor {
    width: 100%;
  }
  // .el-input-number--small{
  //     width: auto;
  // }
  .el-input-number {
    width: 100%;
  }
  // .widthReset .el-form-item__content{width:220px;}
  .colorBtn .el-button {
    background: #f8ab01 !important;
    color: #fff !important;
    border-color: #f8ab01 !important;
  }
  .hide {
    .el-upload--picture-card {
      display: none;
    }
    .el-upload-list {
      display: flex;
      flex-wrap: wrap;
    }
    .el-input__inner {
      width: 100%;
    }
    .el-upload-list__item {
      position: relative;
      overflow: visible;
      margin-bottom: 45px;
      .el-input {
        position: absolute;
        bottom: -33px;
      }
      > div {
        height: 100%;
      }
    }
    .el-upload {
      margin-bottom: 30px;
    }
  }
  .el-card {
    border-radius: 0;
  }
}
</style>
